module.exports = __webpack_public_path__ + "img/engagement.e2873cb.jpg";